export default "/institutions/unicred.svg";